import {
  TBooleanState,
} from '../../utils/boolean.ts';

const tooltip: Record<TBooleanState, string> = {
  nullish: 'Alle',
  true: 'Wahr',
  false: 'Falsch',
};

export default tooltip;
